export default __webpack_public_path__ + "static/media/52.36e6a69d.jpeg";